// Route metadata the shell reads; router.tsx sets it per route.
//   title        default document.title for the route (a page that sets its own title wins: the
//                shell applies the default before the page's effects run)
//   atmosphere   the fixed ground layer, Submit and full-page states only (DESIGN_SPEC §7):
//                "hero"  the page puts its lower content on .flat paper, so the footer joins that band
//                "full"  the whole page sits on the ground, footer included (404, errors)
// useRouteHandle() → { id, title?, atmosphere? } of the deepest matched route
import { useMatches } from "react-router-dom";

export type RouteHandle = { title?: string; atmosphere?: "hero" | "full" };

export function useRouteHandle(): RouteHandle & { id?: string } {
  const matches = useMatches();
  const leaf = matches[matches.length - 1];
  return { id: leaf?.id, ...(leaf?.handle as RouteHandle | undefined) };
}
